export const styles = (theme) => ({
  root: {
    padding: '20px 30px',
    maxWidth: 1280,
    margin: '0 auto',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: theme.spacing(2.5),
    marginBottom: theme.spacing(3),
  },
  spacer: {
    flexGrow: 1,
  },
  purgeBtn: {
    color: theme.palette.textColor.red,
    borderColor: theme.palette.borderColor.red,
    background: 'transparent',
    textTransform: 'none',
    '&:hover, &:focus': {
      background: theme.palette.background.lightRed,
    },
  },
  toolbar: {
    marginBottom: theme.spacing(3),
  },
  descriptionLine: {
    display: 'block',
    '& + &': {
      marginTop: theme.spacing(2),
    },
  },
  empty: {
    color: theme.palette.textColor.secondary,
  },
  loader: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.textColor.secondary,
  },
});
